import React from 'react';
import { Link } from '@sitecore-jss/sitecore-jss-react';
// note we're aliasing the router's link component name, since it conflicts with JSS' link component
import { Link as RouterLink } from 'react-router-dom';

/** React component that turns Sitecore link values that start with / into react-router route links */
const RoutableLink = (props) => {
  const hasValidHref = props.field?.value?.href;
  const isEditing = props?.editable && props?.field?.editable;
    const target = props?.field?.value?.linktype == "external" ? "_blank" : props.field?.value?.target || "_self";

  // only want to apply the routing link if not editing (if editing, need to render editable link value)

  var ariaLabelObj = {};
  if(props?.ariaLabel && props?.ariaLabel.length > 0){
    ariaLabelObj["aria-label"] = props?.ariaLabel;
  }
  if (hasValidHref && !isEditing) {

    const value = props?.field?.value;
    var { field, editable, ariaLabel, ...newProps } = props;

    // determine if a link is a route or not. This logic may not be appropriate for all usages.
    if (value?.href?.startsWith('/')) {
      return (
        <RouterLink to={value.href} {...ariaLabelObj} target={target} {...newProps}>
          {
            <span className='linkText'>
              {props?.children || value?.text || value?.href}
            </span>
          }
        </RouterLink>
      );
    }
  }
  var linkProps = { ...props, field: { value: { ...props?.field?.value, target: target } } };
  var {ariaLabel,...newProps} = linkProps;
  return <Link {...ariaLabelObj} {...newProps}><span className='linkText'>{props?.children}</span></Link>;
};

// usage - drop-in replacement for JSS' Link component
export { RoutableLink }